import React, {useState, useEffect} from 'react';
import CallCenterStructure from '../CallCenterStructure/CallCenterStructure';
import {Times, ViewPen} from '../../assets/icons';
import MenuDeleteModal from '../../component/MenuDeleteModal/MenuDeleteModal';
import styles from '../../styles/ProductGroupMaster.module.scss';
import SearchInput from '../../component/SearchInput/SearchInput';
import {useQuery, useMutation, useQueryClient} from 'react-query';
import axiosProperty from '../../service/HttpConfig';
import ApiConfig from '../../service/ApiConfig';
import Paginate from '../../component/Paginate/Paginate';
import {Headers, RedirectToLogin} from '../../service/Essentials';
import swal from 'sweetalert';
import {ProgramID} from '../../service/Essentials';
import ErrorMessage from '../../component/ErrorMessage/ErrorMessage';
import ClearInputModal from '../../component/ClearInputModal/ClearInputModal';

const ProductGroupMaster = () => {
  const [clearModal, setClearModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [groupCode, setGroupCode] = useState('');
  const [groupName, setGroupName] = useState('');
  const [isUpdate, setIsUpdate] = useState(false);
  const [isSubmit, setIsSubmit] = useState(true);
  const [updateID, setUpdateID] = useState('');
  const [selectedItemID, setSelectedItemId] = useState('');
  const [error, setError] = useState('something went wrong');
  const [errors, setErrors] = useState(null);
  const queryClient = useQueryClient();
  const onClose = () => {
    setDeleteModal(false);
  };

  const formData = {
    group_code: groupCode,
    group_name: groupName,
    company_setup_id: ProgramID(),
  };

  RedirectToLogin();

  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState([]);

  const fetchProductGroups = async page => {
    const res = await axiosProperty.get(
      ApiConfig.fetchProductGroup + `?page=${page}`,
      {
        headers: Headers(),
      },
    );
    return res.data;
  };
  const {data, status} = useQuery(
    ['productgroups', page],
    () => fetchProductGroups(page),
    {keepPreviousData: true},
  );

  useEffect(() => {
    setFilteredData(data?.data || []);
  }, [data]);

  const handleSearchInputChange = searchTerm => {
    setSearchTerm(searchTerm);
    if (searchTerm === '') {
      setFilteredData(data?.data || []); // Reset to original data if search term is empty
    } else if (data?.data) {
      const filtered = data.data.filter(
        (item) =>
          item.group_name.toLowerCase().includes(searchTerm.toLowerCase())||
          item.group_code.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredData(filtered);
    }
  };

  const addProductGroup = async () => {
    try {
      await axiosProperty.post(ApiConfig.createProductGroup, formData, {
        headers: Headers(),
      });
      setGroupCode('');
      setGroupName('');
      setErrors(null);
      swal({
        title: 'Success!',
        text: 'Product group created successfully',
        icon: 'success',
      });
    } catch (err) {
      if (err.response) {
        setError(err.response.data.message);
        setErrors(err.response.data);
      } else {
        setError('Something went wrong, try again');
      }
      console.log(err);
      swal({
        title: "Error!",
        text: error,
        icon:'error'
      });
    }
  };

  const {mutate: addProductGroupMutation} = useMutation({
    mutationFn: addProductGroup,
    onSuccess: () => {
      queryClient.invalidateQueries(['productgroups']);
    },
  });

  const updateProductGroup = async () => {
    try {
      await axiosProperty.patch(
        ApiConfig.updateProductGroup + `/${updateID}`,
        formData,
        {
          headers:Headers(),
      }
        );
        setGroupCode('');
        setGroupName('');
        setIsSubmit(true);
        setIsUpdate(false);
        setErrors(null);

      swal({
        title: 'Success!',
        text: 'Product group updated successfully',
        icon: 'success',
      });
    } catch (err) {
      if (err.response) {
        setError(err.response.data.message);
        setErrors(err.response.data);
      }else{
       setError('Something went wrong, try again'); 
      }
      console.log(err);

      swal({
        title: 'Error!',
        text: error,
        icon: 'error',
      });
    }
  };

  const {mutate: updateProductGroupMutation} = useMutation({
    mutationFn: updateProductGroup,
    onSuccess: () => {
      queryClient.invalidateQueries(['productgroups']);
    },
  });

  const editProductGroup = async id => {
    try {
      const res = await axiosProperty.get(
        ApiConfig.editProductGroup + `/${id}`,
        {
          headers: Headers(),
        },
      );
      setIsUpdate(true);
      setIsSubmit(false);
      setGroupCode(res.data.data.group_code || 'no data');
      setGroupName(res.data.data.group_name || 'no data');
    } catch (err) {
      if (err.response) {
        setError(err.response.data.message);
      } else {
        setError('Something went wrong, try again');
      }
      console.log(err);
      swal({
        title: 'Warning!',
        text: error,
        icon: 'warning',
      });
    }
  };

  const deleteProductGroup = async id => {
    try {
      const res = await axiosProperty.delete(
        ApiConfig.deleteProductGroup + `/${id}`,
        {
          headers: Headers(),
        },
      );
      setDeleteModal(false);
      swal({
        title: 'Success!',
        text: 'Product group deleted successfully',
        icon: 'success',
      });
      queryClient.invalidateQueries(['productgroups']);
    } catch (err) {
      if (err.response) {
        setError(err.response.data.message);
      } else {
        setError('Something went wrong, try again');
      }
      console.log(err);

      swal({
        title: 'Error!',
        text: error,
        icon: 'error',
      });
    }
  };
  return (
    <CallCenterStructure>
      <div className={styles.productGroupMaster}>
        <div className={styles.headerText}>
          <p>Product Group Master</p>
        </div>
        <div className={styles.inputContainer}>
          <div className={styles.fieldContainer1}>
            <div className={styles.innerFieldContainer1}>
              <label htmlFor="">
                Enter Product Group Code<sup>*</sup>
              </label>
              <input
                value={groupCode}
                type="text"
                onChange={e => setGroupCode(e.target.value)}
              />
            </div>
            <div className={styles.innerFieldContainer1}>
              <label htmlFor="">
                Enter Product Group Name<sup>*</sup>
              </label>
              <input
                value={groupName}
                type="text"
                onChange={e => setGroupName(e.target.value)}
              />
            </div>
          </div>

          <div className={styles.buttonContainer}>
            {isSubmit && (
              <button
                className={styles.submit}
                onClick={() => addProductGroupMutation()}>
                Submit
              </button>
            )}
            {isUpdate && (
              <button
                className={styles.submit}
                onClick={() => updateProductGroupMutation()}>
                Update
              </button>
            )}
            <button
              className={styles.reset}
              type="button"
              onClick={() => setClearModal(true)}>
              Reset
            </button>
          </div>
          <ErrorMessage errMsg={errors} />
        </div>
        <div className={styles.inputContainer}>
          <SearchInput onSearchInputChange={handleSearchInputChange} />
          <div className={styles.tableContainer}>
            <table className={styles.mainTable}>
              <thead>
                <tr>
                  <th>Product Group Code</th>
                  <th>Product Group Name</th>
                  {/* <th>Description</th> */}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map(each => (
                    <tr key={each.code}>
                      <td>{each.group_code}</td>
                      <td>{each.group_name}</td>
                      {/* <td>{each.desc}</td> */}

                      <td>
                        <div className={styles.iconContainer}>
                          <span
                            className={styles.icon}
                            onClick={() => {
                              editProductGroup(each.id);
                              setUpdateID(each.id);
                            }}>
                            <ViewPen />
                          </span>
                          <span
                            className={styles.icon}
                            onClick={() => {
                              setDeleteModal(true);
                              setSelectedItemId(each.id);
                            }}>
                            <Times />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colspan="3">No data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className={styles.paginationContainer}>
            {/* <p>Pagination</p> */}
            <Paginate page={page} data={data} setPage={setPage} />
          </div>
        </div>
        {/* Pass your clear input function to clearInputFn */}
        <ClearInputModal
          //   clearInputFn={handleReset}
          clearModalStatus={clearModal}
          clearInputModalState={setClearModal}
        />
        {deleteModal && (
          <MenuDeleteModal
            onClose={onClose}
            onDelete={() => deleteProductGroup(selectedItemID)}
          />
        )}
      </div>
    </CallCenterStructure>
  );
};

export default ProductGroupMaster;
